export const GET_DRIVER = 'GET_DRIVER';
export const GET_VEHICLE = 'GET_VEHICLE';
export const GET_INTERVENTIONS = 'GET_INTERVENTIONS';
export const GET_INTERVENTIONS_HISTORIC = 'GET_INTERVENTIONS_HISTORIC';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_INFO_USER = 'GET_INFO_USER';
export const SET_INFO_USER = 'SET_INFO_USER';
export const GET_TOWNS_BY_CP = 'GET_TOWNS_BY_CP';
export const UPDATE_TOWNS_BY_CP_CACHE = 'UPDATE_TOWNS_BY_CP_CACHE';
export const UPDATE_DRIVER_INFO = 'UPDATE_DRIVER_INFO';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const SEND_MAIL_CONTACT_US = 'SEND_MAIL_CONTACT_US';
export const GET_OPERATIONS_CARD_FUEL = 'GET_OPERATIONS_CARD_FUEL';
export const RESET_INTERVENTIONS = 'RESET_INTERVENTIONS';
export const UPDATE_KMS_OPERATION = 'UPDATE_KMS_OPERATION';
export const SET_VEHICLE_SELECTED = 'SET_VEHICLE_SELECTED';
export const GET_DRIVER_AVATAR = 'GET_DRIVER_AVATAR';
export const SEND_DRIVER_AVATAR = 'SEND_DRIVER_AVATAR';
export const GET_INCIDENT_BY_PROVINCE = 'GET_INCIDENT_BY_PROVINCE';
export const SEND_NOTIFICATION_READED = 'SEND_NOTIFICATION_READED';
export const OFFER_LEGAL_CONDITIONS = 'OFFER_LEGAL_CONDITIONS';
export const APPLIED_CONSENTS = 'APPLIED_CONSENTS';
export const GET_AUTOLOGIN = 'GET_AUTOLOGIN';
export const GET_TYPES_INCIDENTS = 'GET_TYPES_INCIDENTS';
export const GET_LEVEL_2 = 'GET_LEVEL_2';
export const GET_LEVEL_3 = 'GET_LEVEL_3';
export const AUTHORIZATION_VEHICLE_SER_CARD = 'AUTHORIZATION_VEHICLE_SER_CARD';
export const AUTHORIZATION_DEPOSIT_EXIT = 'AUTHORIZATION_DEPOSIT_EXIT';
export const AUTHORIZATION_ACCESORIES_ASSEMBLY = 'AUTHORIZATION_ACCESORIES_ASSEMBLY';
export const FOREIGN_NATIONAL = 'FOREIGN_NATIONAL';
export const GET_REMPLACEMENT_VEHICLE_COVERAGE = 'GET_REMPLACEMENT_VEHICLE_COVERAGE';
export const GET_REMPLACEMENT_VEHICLE_MASTERDATA = 'GET_REMPLACEMENT_VEHICLE_MASTERDATA';
export const REMPLACEMENT_VEHICLE_PROCESS_REQUEST = 'REMPLACEMENT_VEHICLE_PROCESS_REQUEST';
export const RESET_REMPLACE_VEHICLE = 'RESET_REMPLACE_VEHICLE';
export const CREATE_CRM_WEB_CONDUCTORES = 'CREATE_CRM_WEB_CONDUCTORES';
export const GET_TOWNS_BY_PROVINCE_CODE = 'GET_TOWNS_BY_PROVINCE_CODE';
export const UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE = 'UPDATE_TOWNS_BY_PROVINCE_CODE_CACHE';
